"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _elementLocator = require("../../../core/utils/elementLocator");
require("./Image.scss");
var _excluded = ["className", "src", "srcset", "sizes", "placeholderSrc", "alt", "inheritedStyles", "ref", "elementLocator", "loading"];
var Image = function Image(_ref) {
  var className = _ref.className,
    src = _ref.src,
    srcset = _ref.srcset,
    sizes = _ref.sizes,
    placeholderSrc = _ref.placeholderSrc,
    alt = _ref.alt,
    inheritedStyles = _ref.inheritedStyles,
    ref = _ref.ref,
    elementLocator = _ref.elementLocator,
    loading = _ref.loading,
    other = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return _react.default.createElement("img", (0, _extends2.default)({
    className: "image-container " + className,
    src: src,
    srcSet: srcset || null,
    sizes: sizes || null,
    alt: alt,
    ref: ref,
    loading: loading,
    "data-locator": elementLocator || "image-" + (0, _elementLocator.getLabelFromChildren)(alt)
  }, other, {
    onError: placeholderSrc ? function (event) {
      // eslint-disable-next-line no-param-reassign
      event.target.src = placeholderSrc;
    } : null
  }));
};
Image.defaultProps = {
  className: '',
  alt: '',
  src: '',
  srcset: '',
  sizes: '',
  placeholderSrc: '',
  inheritedStyles: '',
  loading: 'auto',
  elementLocator: '',
  ref: function ref() {
    /* default ref handler */
  }
};
var _default = Image;
exports.default = _default;
module.exports = exports["default"];